import { render, staticRenderFns } from "./header-tdb.vue?vue&type=template&id=66e385c0&scoped=true&"
import script from "./header-tdb.vue?vue&type=script&lang=ts&"
export * from "./header-tdb.vue?vue&type=script&lang=ts&"
import style0 from "./header-tdb.vue?vue&type=style&index=0&id=66e385c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e385c0",
  null
  
)

export default component.exports